import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FUtil, FServiceAPI } from '@freelog/tools-lib';
import { onlineExhibit } from '@/utils/nodeTools';
import { listStateAndListMore } from '@/components/FListFooter';
import type {
  NodeManagerModelState,
  ChangeAction,
  OnMount_ThemePage_Action,
  OnUnmount_ThemePage_Action,
  OnChangeThemeAction,
  OnActiveAction,
  FetchThemesAction,
} from './types';
import { themeInitStates } from './initialState';

export const themeEffects = {
  *onMount_ThemePage({}: OnMount_ThemePage_Action, { select, put }: EffectsCommandMap) {
    // console.log('onMount_ThemePage 3w2890iojhsdfjsdlfjsldjl');
    yield put<FetchThemesAction>({
      type: 'fetchThemes',
      payload: {
        restart: true,
      },
    });
  },
  *onUnmount_ThemePage({}: OnUnmount_ThemePage_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...themeInitStates,
      },
    });
  },
  *onActive({ payload }: OnActiveAction, { call, select, put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        theme_ActivatingThemeID: payload.id,
      },
    });

    yield call(onlineExhibit, { exhibit_ID: payload.id });

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        theme_ActivatingThemeID: '',
      },
    });

    yield put<FetchThemesAction>({
      type: 'fetchThemes',
    });
  },
  *onChangeTheme({ payload }: OnChangeThemeAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        theme_InputFilter: payload.themeInputFilter,
      },
    });
    yield put<FetchThemesAction>({
      type: 'fetchThemes',
    });
  },

  *fetchThemes({}: FetchThemesAction, { call, put, select }: EffectsCommandMap) {
    // console.log(23423423, '0923jfdslk');
    const { nodeManagerPage }: ConnectState = yield select(
      ({ nodeManagerPage }: ConnectState) => ({
        nodeManagerPage,
      }),
    );

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        theme_ListState: 'loading',
      },
    });

    const params: Parameters<typeof FServiceAPI.Exhibit.presentables>[0] = {
      nodeId: nodeManagerPage.nodeId,
      limit: FUtil.Predefined.pageSize,
      keywords: nodeManagerPage.theme_InputFilter || undefined,
      onlineStatus: 2,
      resourceType: '主题',
      isLoadVersionUpdateTip: 1,
      isLoadVersionProperty: 1,
    };
    // i.versionUpdateTipStatus
    const {
      data,
    }: {
      data: {
        dataList: any[];
        totalItem: number;
      };
    } = yield call(FServiceAPI.Exhibit.presentables, params);

    if (data.dataList.length === 0) {
      if (nodeManagerPage.theme_InputFilter === '') {
        yield put<ChangeAction>({
          type: 'change',
          payload: {
            theme_ListState: 'noData',
            theme_ListMore: 'noMore',
            theme_List: [],
          },
        });
      } else {
        yield put<ChangeAction>({
          type: 'change',
          payload: {
            theme_ListState: 'noSearchResult',
            theme_ListMore: 'noMore',
            theme_List: [],
          },
        });
      }
      return;
    }

    let batchAuthTs: any[] = [];
    const params1: Parameters<typeof FServiceAPI.Exhibit.batchAuth>[0] = {
      nodeId: nodeManagerPage.nodeId,
      authType: 3,
      presentableIds: (data.dataList as any[])
        .map<string>((dl: any) => {
          return dl.presentableId;
        })
        .join(','),
    };
    const { data: data1 } = yield call(FServiceAPI.Exhibit.batchAuth, params1);
    batchAuthTs = data1;

    const theme_List: NodeManagerModelState['theme_List'] = data.dataList
      .map<NodeManagerModelState['theme_List'][number]>((i) => {
        const authInfo = batchAuthTs.find((bap: any) => bap.presentableId === i.presentableId);
        return {
          id: i.presentableId,
          cover: i.coverImages[0],
          title: i.presentableTitle || i.presentableName,
          version: i.version,
          isOnline: i.onlineStatus === 1,
          policies: (i.policies as any[])
            .filter((p: any) => p.status === 1)
            .map<string>((p) => p.policyName),
          hasPolicy: i.policies.length > 0,
          isAuth: authInfo.isAuth,
          authErrorText: authInfo.error,
          resourceId: i.resourceInfo?.resourceId,
          hasUpdateVersion:
            i.versionUpdateTipStatus === 1
              ? 'noUpdate'
              : i.versionUpdateTipStatus === 2
              ? 'hasUpdate'
              : 'ignored',
          resourceLatestVersion: i.resourceInfo.latestVersion,
          autoUpdate: i.autoUpdateStatus === 1,
        };
      })
      .sort((a, b) => {
        if (a.isOnline && !b.isOnline) {
          return -1;
        }
        return 0;
      });
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        theme_ListState: 'loaded',
        theme_ListMore: data.totalItem > theme_List.length ? 'andMore' : 'noMore',
        theme_List: theme_List,
        // listFirstLoaded: true,
      },
    });
  },
};
